import { isValidElement } from "react";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";

const Box = ({ children, link, className }) => {
	if (link) {
		return (
			<a
				className={className}
				href={link}
				target="_blank"
				rel="noreferrer noopener"
			>
				{children}
			</a>
		);
	}

	return <div className={className}>{children}</div>;
};

function Hint({ className, hint, Trigger, link }) {
	const renderTrigger = () => {
		if (isValidElement(Trigger)) {
			return Trigger;
		}

		return <div className="circle-trigger">{Trigger || "?"}</div>;
	};

	return (
		<Box className={className} link={link}>
			<Tooltip title={hint}>{renderTrigger()}</Tooltip>
		</Box>
	);
}

export default Hint;
